export const getCityCenter = (city) => ({
    cd: [104.065735,30.659462],
    nj: [118.802422,32.043352],
    hz: [120.171816,30.228371],
    wh: [114.278241,30.59026],
    xa: [108.938468,34.276656],
    sh: [121.429784,31.224502],
    cs: [108.938468,34.276656],
    sz: [108.938468,34.276656]
}[city])